import React from "react";
import { useStyles } from "./style";
import { Link } from "gatsby";

const regex = /(<([^>]+)>)/gi;

export default function Masonry({ itemStyle, pdTop, post }) {
  const classes = useStyles();
  const postExcerpt = post.excerpt.replace(regex, "");

  return (
    <div className={classes.vglPost}>
      <div
        className={classes.vglFeaturedImage}
        style={{ paddingTop: pdTop ? pdTop : 0 }}
      >
        <div
          style={{
            backgroundImage: `url(${post?.featuredImage?.node?.mediaItemUrl})`,
            height: itemStyle.img.height,
          }}
        >
          <Link to={post?.uri} title={post?.title}></Link>
        </div>
      </div>
      <div className={classes.vglPostInfo}>
        <Link
          to={post?.uri}
          title="(Skincare) virgin diaries: Serum is the sweet spot of my skincare routine"
        >
          <h3 style={{ fontSize: itemStyle.title.fontSize }}>{post?.title}</h3>
        </Link>
        <div className={classes.vglPostInfo__excerpt}>
          <span
            dangerouslySetInnerHTML={{
              __html: `${postExcerpt.substring(0, 150)}`,
            }}
          ></span>
        </div>
        <span className={classes.vglPostNameCategory}>
          <b>by</b>
          <span className={classes.vglPostAuthor}>
            {post?.author?.node?.name}
          </span>
          |
          <span className={classes.vglPostCategory}>
            {post?.categories?.nodes[0]?.name}
          </span>
        </span>
        <Link
          className={classes.vglPostReadMore}
          title={post?.title}
          to={post?.uri}
        >
          Read More
        </Link>
      </div>
    </div>
  );
}
